import i18n from 'i18next';
import { registerValidator } from 'core/forms';

const isNotEmptyArray = ({ fieldValue }) => ({
  error: i18n.t('error-required-field-error'),
  hasError: Array.isArray(fieldValue) && !fieldValue.length,
  isRequired: true,
});

registerValidator('isNotEmptyArray', isNotEmptyArray);

export default isNotEmptyArray;
